import router from "@/router";
import { SaveState, saveDrawing } from "@/stores/SaveDrawingState";

/**
 * Recharge complètement l'application — le seul moyen de rendre au navigateur la
 * mémoire retenue par le module WASM et les caches ODA.
 *
 * Sauvegarde d'abord le dessin ouvert s'il a des modifications en attente : sans
 * ça le `beforeunload` de DrawingCanvas.vue interceptrait le rechargement avec
 * une confirmation native, et l'utilisateur perdrait son travail s'il confirme.
 *
 * Partagé par le bouton permanent de la navbar, le bandeau mémoire et l'alerte
 * mémoire du canvas.
 */
export async function reloadApp(): Promise<void> {
  if (
    router.currentRoute.value.name === "canvas" &&
    SaveState.value === "changed"
  ) {
    await saveDrawing(false);
  }
  window.location.reload();
}
